import UploadImgCropperNew from './main.vue'

/* istanbul ignore next */
UploadImgCropperNew.install = function(Vue) {
  Vue.component(UploadImgCropperNew.name, UploadImgCropperNew)
}

export default UploadImgCropperNew
